import React from 'react';

import TestimonialImg from '../assets/img/teasti.png'
import starIcon from '../assets/img/star.png';
import quiteIcon from '../assets/img/quit.svg';


const Testimonials = () => {
    return (
        <section className="testimonials-sec">
            <div className="container c_container">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="testimo-left" data-aos="fade-up">
                        <img src={TestimonialImg} alt="" className="w-100" />
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="testimo-right">
                            <h6 className="small-heading" data-aos="fade-up">Testimonials</h6>
                            <h3 className="heading-gradient" data-aos="fade-up">What They Says About Flower Medical</h3>
                            <p className="para-16" data-aos="fade-up">A differentiator for nursing homes, primary centres, events companies and other healthcare facilities</p>
                            <div className="testimo-review">
                                <div className="d-flex justify-content-between" data-aos="fade-up">
                                    <img src={starIcon} alt="" />
                                    <img src={quiteIcon} alt="" />
                                </div>
                                <p data-aos="fade-up">Working with primary care centres, hospitals and healthcare providers nationwide, we set up an X-ray department, including equipment and staff, for a half-day, day or number of days per week</p>
                                <h6 data-aos="fade-up">On-Site X-ray Department</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;